
import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import { Link } from 'react-router'
import ShowHide from './ShowHide'
import Badge from './Badge'
import './NavigationMenu.css'

const Menu = props => {
  const { children, size } = props
  return (
    <div className='NavigationMenu' size={size}>
      {children}
    </div>
  )
}

const MenuLink = props => {
  let { rel, type, active, url, onSelect, count, countType } = props
  let label = props.children || type

  let classes = classnames({
    'NavigationMenu-link': true,
    active: !!active
  })

  const onClick = () => {
    if (!active) {
      onSelect()
    }
  }

  const linkAttrs = {
    rel,
    className: classes
  }

  if (onSelect) {
    linkAttrs.onClick = onClick
  }

  // use `to={url}` to prevent full reload when. use
  // `href={url}` with `rel=external` to force reloads.
  if (rel === 'external') {
    linkAttrs.href = url
  } else {
    linkAttrs.to = url
  }

  // render template.
  return (
    <Link {...linkAttrs}>
      <div className='NavigationMenu-left'>
        {label}
      </div>
      <div className='NavigationMenu-right'>
        <Badge value={count} type={countType} />
      </div>
    </Link>
  )
}

const MenuGroup = props => {
  let { title, children } = props
  return (
    <div className='NavigationMenu-group'>
      <ShowHide show={title}>
        <span className='NavigationMenu-groupTitle'>{title}</span>
      </ShowHide>
      {children}
    </div>
  )
}

Menu.displayName = 'Menu'

Menu.propTypes = {
  children: PropTypes.array.isRequired,
  size: PropTypes.string
}

MenuLink.displayName = 'MenuLink'

MenuLink.propTypes = {
  rel: PropTypes.string,
  type: PropTypes.string,
  active: PropTypes.bool.isRequired,
  url: PropTypes.string,
  onSelect: PropTypes.func,
  count: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  countType: PropTypes.string,
  children: PropTypes.string.isRequired
}

MenuGroup.displayName = 'MenuGroup'

MenuGroup.propTypes = {
  title: PropTypes.string,
  children: PropTypes.element.isRequired
}

export { Menu, MenuLink, MenuGroup }



// WEBPACK FOOTER //
// ./ui/NavigationMenu.js